export const supplierFr = {
  "Nom": "Nom",
  "Telephone": "Telephone",
  "Balance": "Balance",
  "Actions": "Actions",
  "Chercher un Founisseur": "Chercher un Founisseur",

  "Montant": "Montant",
  "Note": "Note",
  "Date": "Date",
  "Aujourd'hui": "Aujourd'hui",
  "Choisir un fournisseur": "Choisir un fournisseur",
  "Information du fournisseur": "Information du fournisseur",
  
}